/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { MonthInDays } from "../../staffhub/StaffHubConstants";

import { PastDateLimitOption } from "./PastDateLimitOption";

const { twoMonths, threeMonths, fourMonths, fiveMonths, sixMonths } = MonthInDays;
/**
 * List of months for dropdown menu, and corresponding number of days.
 */
export const dateLimitsList: PastDateLimitOption[] = [
    { monthsCount: 2, daysCount: twoMonths },
    { monthsCount: 3, daysCount: threeMonths },
    { monthsCount: 4, daysCount: fourMonths },
    { monthsCount: 5, daysCount: fiveMonths },
    { monthsCount: 6, daysCount: sixMonths }
];
